import React, { createContext, useContext, useEffect, useState } from 'react';
import Script from 'next/script';
import { useRouter } from 'next/router';

const BotMakerContext = createContext();

function BotMakerProvider({ children, locale }) {
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  const isBlocked = (page) => {
    const urlPathname = page.includes('://') ? new URL(page).pathname : page;
    const result = blockList.includes(urlPathname);
    return result;
  };

  useEffect(() => {
    if (router?.asPath) {
      setCurrentPage(router.asPath);
      setIsLoaded(true);
    }
  }, [router]);

  const blockList = [
    "/mi-toyota/conectado",
    "/mi-toyota/conectado/funciones",
    "/mi-toyota/conectado/planes",
  ];

  return (
    <BotMakerContext.Provider value={{ locale }}>
      {children}

      {isLoaded && locale === 'es-ar' && isBlocked(currentPage) && (
        <Script
          id="custom-chatbot-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
             (function () {
               let js = document.createElement('script');
               js.type = 'text/javascript';
               js.async = 1;
               js.src = 'https://go.botmaker.com/rest/webchat/p/Z321D01T4C/init.js';
               document.body.appendChild(js);
             })();
           `,
          }}
        />
      )}

      {isLoaded && locale === 'es-ar' && !isBlocked(currentPage) && (
        <Script
          id="botmaker-script"
          strategy="afterInteractive"
          src="https://go.botmaker.com/rest/webchat/p/0BOZKVI13N/init.js"
        />
      )}
    </BotMakerContext.Provider>
  );
}

function useBotMaker() {
  const context = useContext(BotMakerContext);
  if (context === undefined) {
    throw new Error('useBotMaker must be used within a BotMakerProvider');
  }

  return context;
}

export { BotMakerProvider, BotMakerContext, useBotMaker };
